var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-home perform-home"},[_c('board-list-component',{attrs:{"boardType":`perform`,"defaultFilter":_vm.defaultFilter}})],1),_c('page-footer',{attrs:{"performKey":_vm.defaultFilter.pid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }